import initializers from '../dependencies/initializers'

export async function fetchWeeklyDemoData() {
  try {
    const response = await fetch(`${initializers.api_host}/public/v1/weekly-demo`);
    if (response.ok) {
      const data = await response.json();
      return {
        title: data.title,
        desc: data.desc,
        image_url: data.image_url,
        webinar_link: data.webinar_link
      };
    }
  } catch (error) {
    console.error('Error fetching weekly demo data:', error);
  }
  // Default data if API fails
  return {
    title: "",
    desc: "",
    image_url: "",
    webinar_link: ""
  };
}